<template>
  <section v-lenis-scroll class="shopmaison_banner">
    <div>
      <div class="imagebox">
        <!-- Background images with dynamic URLs -->
        <div class="bgimageone" :style="{ backgroundImage: 'url(' + backgroundImage1 + ')' }" />
        <div class="bgimagetwo" :style="{ backgroundImage: 'url(' + backgroundImage2 + ')' }" />
      </div>

      <!-- Centered text image -->
      <div class="shopmaison_banner_textImage">
        <img v-lazy="shopifyData.textImage" alt="Text Image" class="firstsectext" />
      </div>

      <!-- Logo section -->
      <div class="logobox">
        <img v-lazy="shopifyData.logo" alt="logo" />
      </div>

      <!-- Textbox section -->
      <div class="textbox">
        <div style="height: 500px" />
        <p>
          {{ shopifyData.custom_info }}
        </p>
      </div>
    </div>
  </section>
</template>

<script>
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

export default {
  props: {
    shopifyData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      backgroundImage1: this.shopifyData.image1, // Default to desktop background
      backgroundImage2: this.shopifyData.image2, // Default to desktop background
    };
  },
  mounted() {
    // window.addEventListener("load", () => {
    //       console.log("Window fully loaded, shopifyData:", this.shopifyData);
    // });
    this.updateBackgroundImage(); // Call once when the component is mounted

    // Add a resize event listener
    window.addEventListener('resize', this.updateBackgroundImage);

    gsap.registerPlugin(ScrollTrigger);

    gsap
      .timeline({
        scrollTrigger: {
          trigger: '.imagebox',
          start: 'top 0%',
          end: 'bottom -100%',
          pin: true,
          pinSpacing: false,
          scrub: true,
        },
      })
      .to('.imagebox', {
        scale: 1.2,
        ease: 'power1.out',
      });

    gsap
      .timeline({
        scrollTrigger: {
          trigger: '.logobox',
          start: 'top  80%',
          end: 'bottom top',
          pin: true,
          pinSpacing: false,
          scrub: true,
        },
      })
      .fromTo(
        '.bgimagetwo',
        {
          opacity: 0,
          delay: 0.8,
        },
        {
          opacity: 1,
          scale: 1.2,
        },
        '>'
      )
      .fromTo(
        '.bgimageone',
        {
          opacity: 1,
          delay: 0.8,
        },
        {
          opacity: 0,
          scale: 1.2,
        },
        '>'
      );

    gsap.timeline({
      scrollTrigger: {
        trigger: '.textbox',
        start: '20% bottom',
        end: '20% bottom',
        scrub: true,
        pin: true,
        pinSpacing: false,
      },
    });
  },

  beforeUnmount() {
    // Clean up the event listener when the component is destroyed
    window.removeEventListener('resize', this.updateBackgroundImage);
  },
  methods: {
    updateBackgroundImage() {
      if (window.innerWidth <= 676) {
        this.backgroundImage1 = this.shopifyData.image1Mob;
        this.backgroundImage2 = this.shopifyData.image2Mob;
      } else {
        this.backgroundImage1 = this.shopifyData.image1;
        this.backgroundImage2 = this.shopifyData.image2;
      }
    },
  },
};
</script>

<style scoped>
.imagebox {
  position: relative;
  width: 100%;
  height: 100vh;
}

.shopmaison_banner_textImage {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  height: auto;
  width: 100%;
  top: 57%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.firstsectext {
  max-width: 528px;
  width: 100%;
}

.logobox img {
  max-width: 268px;
  width: 100%;
}

.bgimageone,
.bgimagetwo {
  background-repeat: no-repeat;
  background-size: cover;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1;
  background-position: center;
}

.logobox {
  height: 100vh;
  position: relative;
  z-index: 2;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}

.textbox {
  height: 100vh;
  position: relative;
  z-index: 2;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.textbox p {
  font-family: 'Adobe Caslon Pro', serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 16.8px;
  letter-spacing: 0.02em;
  text-align: center;
  color: #fff;
  max-width: 392px;
  width: 100%;
}

section {
  overflow: hidden;
}

@media screen and (max-width: 567px) {
  .shopmaison_banner {
    margin-top: 170px;
  }

  .textbox p {
    max-width: 317px;
    width: 100%;
  }

  .bgimageone,
  .bgimagetwo {
    left: -25%;
  }
}
</style>
